module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_TOC_Heading",
    attrs: {
      "id": "tableofcontents"
    }
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0001#auto_bookmark_toc_1"
    }
  }, [_vm._v("Blurb")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0003#auto_bookmark_toc_1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0004#auto_bookmark_toc_1"
    }
  }, [_vm._v("Part 1: Therapy")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0005#auto_bookmark_toc_1"
    }
  }, [_vm._v("Chapter 1: David")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0006#auto_bookmark_toc_1"
    }
  }, [_vm._v("Chapter 2: No Pain, No Gain")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0007#auto_bookmark_toc_1"
    }
  }, [_vm._v("Chapter 3: Starting Therapy")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0008#auto_bookmark_toc_1"
    }
  }, [_vm._v("Chapter 4: Progress")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0009#auto_bookmark_toc_1"
    }
  }, [_vm._v("Chapter 5: Brandon With Friends")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0010#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Ask Me Out")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0011#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: First Date")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0012#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Walking the Neighborhood")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0013#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: In the Bedroom")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0014#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Afterward")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0015#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: The Second Date")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0016#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Back to Before")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0017#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Sunday In Washington")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0018#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Exposure")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0019#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Confessions")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0020#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Dinner with Friends")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0021#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Run")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0022#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Kickball")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0023#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Try")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0024#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2: Provincetown")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0025#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Anticipation of Summer")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0026#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: Arrival")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0027#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Home")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: Long Point Light")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0029#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: The Party")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0030#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: Dark Night")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0031#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3: Loss")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0032#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26: The Harsh Months")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0033#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27: The Fall")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0034#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28: A Second Chance")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0035#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 4: Recovery")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0036#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29: A Very Bad Day")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0037#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30: Scars")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0038#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31: Too Much Time")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0039#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32: Give Thanks")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0040#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33: The Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0041#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34: Homecoming")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0042#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35: Forward")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0043#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36: All Ye Faithful")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0044#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0045#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coming in 2017")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0046#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0047#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("By Robert Winter")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Visit Dreamspinner Press")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0049#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0